// import {getUrlParam, setLocalData} from 'utils/util';
const isTest = (process.env.BUILD_TEST || process.env.NODE_ENV === 'development')
// export const xauth_ticket = getUrlParam('nextUrl');
export const xauthUrl = !isTest ?
    'https://xauth.shijieu.cn' :
    'http://xauth.t.shijieu.cn';
export const xauthApi = !isTest ?
    'https://api.xauth.shijieu.cn' :
    'http://api.xauth.t.shijieu.cn';
export const studentOrigin = !isTest ? 'https://xs.shijieu.cn' : 'http://xs.t.shijieu.cn';
export const parentsOrigin = !isTest ? 'https://jz.shijieu.cn' : 'http://jz.t.shijieu.cn';
export const studentLoginUrl = xauthUrl + '/xauth/user/login?xauth_redirect=' + studentOrigin + '/#/student/studentlogin';
export const parentsLoginUrl = xauthUrl + '/xauth/user/login?xauth_redirect=' + parentsOrigin + '/parents/#/parents/parentslogin';
export const xbagUrl = !isTest ? 'http://xs.shijieu.cn/xstatic/xbag/college/' : 'http://xs.t.shijieu.cn/xstatic/xbag/college/';
export const hideShiJieSchoolNames=['紫光教育平台','晓羊教育云平台',];
export const xkCoachLimitSchoolCodes=["623637","777881"];



// WEBPACK FOOTER //
// ./src/constants/constants.js